const view = /*html*/`

    
    <div id="kt_content_container" class="container-xxl">
        

        
        <div class="d-flex flex-row flex-wrap align-items-center gap-2 align-items-center justify-content-center mb-4 w-100 selectors">            
            <button class="btn btn-sm btn-flex btn-color-gray-muted border border-muted border-active-info border-hover-info btn-active-light-info btn-active-color-info selector selector-all active" selector="all">
                <span class="teko-header text-uppercase">All</span>
            </button>
            <button class="btn btn-sm btn-flex btn-color-gray-muted border border-muted border-active-info border-hover-info btn-active-light-info btn-active-color-info selector selector-csdm d-none"  selector="csdm">
                <span class="teko-header text-uppercase">Deathmatch</span>
            </button>
            <button class="btn btn-sm btn-flex btn-color-gray-muted border border-muted border-active-info border-hover-info btn-active-light-info btn-active-color-info selector selector-retake d-none"  selector="retake">
                <span class="teko-header text-uppercase">Retakes</span>
            </button>
            <button class="btn btn-sm btn-flex btn-color-gray-muted border border-muted border-active-info border-hover-info btn-active-light-info btn-active-color-info selector selector-wallbang d-none"  selector="wallbang">
                <span class="teko-header text-uppercase">Wallbang</span>
            </button>
            <button class="btn btn-sm btn-flex btn-color-gray-muted border border-muted border-active-info border-hover-info btn-active-light-info btn-active-color-info selector selector-config d-none"  selector="config">
                <span class="teko-header text-uppercase">Config</span>
            </button>
        </div>
            
        
        <div class="d-flex flex-column">
            
            <div class="flex-row-fluid mb-12 servers-section section-csdm d-none">
                <div class="card mb-4">
                    <div class="card-header border-0 flex-nowrap">
                        <h3 class="card-title gap-3">
                            
                            <span class="teko-header text-dark text-uppercase lh-1">Deathmatch</span>
                            <!--<span class="text-muted fs-7 text-nowrap"><span class="servers-quantity">0</span> <span>Servers</span></span>-->
                            <span class="badge badge-light fs-8 text-nowrap"><span class="servers-quantity">0</span> <span>Servers</span></span>
                            
                            
                            <div class="fs-8 text-gray-700 px-6">Si estás buscando practicar tu puntería, nuestros servidores de CSDM son la solución perfecta. Usa nuestros servidores de alta gama y alto rendimiento de 1000FPS que hemos facilitado y hecho conveniente para que puedas concentrarte en mejorar tus habilidades.</div>
                        </h3>
                        <div class="card-toolbar">
                            <div class="d-flex justify-content-end">
                                <button type="button" class="btn btn-flex btn-light-primary btn-active-primary btn-active-color-gray-200 mm-quick-match" data-type="csdm" data-mode="practice">
                                    <i class="far fa-bolt me-2 fs-2"></i>
                                    <span class="fs-8 fw-bolder text-uppercase">Quick Start</span>
                                </button>
                            </div>                            
                        </div>
                    </div>
                </div>

                <div class="d-table w-100">
                    <div class="d-table-row fw-bold text-gray-800 teko-semibold fs-4 bg-gray-100 servers-list type-csdm">
                        <div class="d-table-cell py-2 px-3 ps-4 rounded-start">
                            <span class="text-dark">#</span>
                        </div>
                        <div class="d-table-cell py-2 px-3 text-center">
                            <span class="text-dark">Players</span>
                        </div>
                        <div class="d-table-cell py-2 px-3">
                            <span class="text-dark">Location</span>
                        </div>
                        <div class="d-table-cell py-2 px-3">
                            <span class="text-dark">Ping</span>
                        </div>
                        <div class="d-table-cell py-2 px-3">
                            <span class="text-dark">Map</span>
                        </div>
                        <div class="d-table-cell py-2 px-3 pe-4 rounded-end text-center">
                            <span class="text-dark text-center">Join</span>
                        </div>
                    </div>                    
                </div>
            </div>

            <div class="flex-row-fluid mb-12 servers-section section-retake  d-none">
                <div class="card">
                    <div class="card-header border-0 flex-nowrap">
                        <h3 class="card-title gap-3">
                            <span class="teko-header text-dark text-uppercase lh-1">Retakes</span>
                            <span class="badge badge-light fs-8 text-nowrap"><span class="servers-quantity">0</span> <span>Servers</span></span>
                            <div class="fs-8 text-gray-700 px-6">Recuperar un bombsite puede ser tan desafiante como hacer un clutch. Pero con nuestros servidores puedes practicar esas situaciones de afterplant. ¡Únete a nuestros servidores de retake ahora mismo para practicar diferentes escenarios!</div>
                        </h3>
                        <div class="card-toolbar">
                            <div class="d-flex justify-content-end">
                                <button type="button" class="btn btn-flex btn-light-primary btn-active-primary btn-active-color-gray-200" disabled>
                                    <i class="far fa-bolt me-2 fs-2"></i>
                                    <span class="fs-8 fw-bolder text-uppercase">Quick Start</span>
                                </button>
                            </div>                            
                        </div>
                    </div>
                </div>               
            </div>

            <div class="flex-row-fluid mb-12 servers-section section-wallbang  d-none">
                <div class="card">
                    <div class="card-header border-0 flex-nowrap">
                        <h3 class="card-title gap-3">
                            <span class="teko-header text-dark text-uppercase lh-1">Wallbang</span>
                            <span class="badge badge-light fs-8 text-nowrap"><span class="servers-quantity">0</span> <span>Servers</span></span>
                            <div class="fs-8 text-gray-700 px-6">¿Quieres mejorar tus habilidades de wallbang? Sorprende a tus enemigos wallbangs perfectos. Con una configuración especial para cada jugador y mapas personalizados, puedes practicar tus habilidades de wallbang y sorprender a todos.</div>
                        </h3>
                        <div class="card-toolbar">
                            <div class="d-flex justify-content-end">
                                <button type="button" class="btn btn-flex btn-light-primary btn-active-primary btn-active-color-gray-200" disabled>
                                    <i class="far fa-bolt me-2 fs-2"></i>
                                    <span class="fs-8 fw-bolder text-uppercase">Quick Start</span>
                                </button>
                            </div>                            
                        </div>
                    </div>
                </div>               
            </div>

        </div> 

    </div>


`;


export default view;